import { useState } from "react";
import styles from "./RankingPage.module.scss"
import { FormThursdayComponent } from "./form_thursday/component";
import { ClassementComponent } from "./classement/component";
import { RegisterThursdayComponent } from "./register_thursday/component";

function Ranking() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <>
    <section className={styles.main}>
      <div className={styles.container}>
        <FormThursdayComponent onRegistered={() => setRefreshKey((k) => k + 1)} />
        <RegisterThursdayComponent refreshKey={refreshKey} />
        <ClassementComponent league="thursday" />
      </div>
    </section>
    </>
  );
}

export default Ranking;



